/**
 * Allows to read session storage data based on a specific key and return the found values
 * @param key | name of a key in the session storage
 * @returns string | null | undefined
 */
export const getSessionStorageItem = (
  key: string
): string | null | undefined => {
  if (key && key !== "") {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      console.error(`[SessionStorage] Error getting item: ${key}`, e);
      return null;
    }
  }
};

/**
 * Allows to save session storage data based on a specific key
 * @param key | name of a key in the session storage
 * @param data | found session storage data
 */
export const setSessionStorageItem = (key: string, data = ""): void => {
  if (key && key !== "") {
    try {
      window.sessionStorage.setItem(key, data);
    } catch (e) {
      console.error(`[SessionStorage] Error adding item: ${key}`, e);
    }
  }
};

/**
 * Allows to remove session storage data based on a specific key
 * @param key | name of a key to remove of the session storage
 */
export const removeSessionStorageItem = (key: string): void => {
  if (key && key !== "") {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {
      console.error(`[SessionStorage] Error removing item: ${key}`, e);
    }
  }
};
